<template lang="pug">
.product(
  @click="select",
  :class="{ selected, viable, 'out-of-stock' : this.isOutOfStock  }",
  role="button",
  tabindex="0"
)
  .product__inner
    img.product-image(:src="product.image")
    p.product-name {{ product.name }}
    template(v-if="isOutOfStock")
        span.out-of-stock {{this.outOfStock}}
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
export default {
  name: "SelectionProduct",
  props: ["product", "parameter"],
  computed: {
    ...mapGetters(["model", "outOfStock"]),
    selected() {
      return this.model[this.parameter] === this.product.sku;
    },
    viable() {
      return this.product.viable;
    },
    isOutOfStock() {
      let isOutOfStock = false;
      if (this.parameter !== 'cable') {
        if (this.model.cable) {
          let child = this.product.children.find(x => x.meta.compatibility[0] === this.model.cable);
          isOutOfStock = this.product.meta.isOutOfStock || child?.meta.isOutOfStock;
        }
        else {
          isOutOfStock = this.product.meta.isOutOfStock;
        }
      }
      return isOutOfStock;
    }
  },
  methods: {
    ...mapMutations(["setModel"]),
    select() {
      const {
        parameter,
        product: { sku },
      } = this;
      if (this.isOutOfStock)
          return alert(this.outOfStock);
      this.setModel({ parameter, value: sku });
      this.$emit("selected");
    },
  },
};
</script>

<style lang="scss" scoped>
.product {
  display: flex;
  background: $white;
  border: 1px solid $midGray;
  position: relative;
  grid-area: span 1 / span 1;
  cursor: pointer;
  transition: all 0.5s;
  justify-content: center;

  &.out-of-stock{
    background: $midGray;
  }

  &:not(.viable) {
    opacity: 0.35;
    filter: grayscale(50%) brightness(90%);
    &:hover {
      opacity: 0.5;
      filter: grayscale(20%) brightness(95%);
    }
  }

  &.selected {
    border: 1px solid $darkGray;
    outline: 2px solid $darkGray;
  }

  &::before {
    content: "";
    display: block;
    position: relative;
    padding-top: calc(80% + 1rem);
  }

  &__inner {
    display: flex;
    flex-direction: column;
    //position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }

  &-image {
    //padding: 0.75rem;
    object-fit: scale-down;
    flex: 1 1 100%;
    @include mq(md) {
      max-width: 150px;
      margin: auto;
    }
  }

  &-name {
    margin-top: auto;
    border-top: 1px solid lighten($midGray, 7%);
    flex: 0 0 auto;
    margin: 0;
    text-align: center;
    padding: 1rem 1.25rem;
    font-size: 0.875rem;
  }
}

span.out-of-stock{
    color: red;
    text-align: center;
}
</style>